import React, { useState, useEffect } from "react";

export const svg = `<svg width="40" height="40" viewbox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="8" fill="url(#overlay-icon-a)" fill-opacity=".15"></rect><g opacity=".5"><path d="m28.534 21.28-1.756 1.246 1.135.806a.208.208 0 0 1 0 .337l-.642.455 1.756 1.247.026-.02c1.263-.895 1.263-2.806 0-3.702l-.52-.37Z" fill="url(#overlay-icon-b)"></path><path d="m13.222 22.526-1.755-1.246-.52.369c-1.263.896-1.263 2.806 0 3.703l.026.018 1.756-1.246-.642-.455a.208.208 0 0 1 0-.337l1.135-.806Z" fill="url(#overlay-icon-c)"></path><path d="m12.73 26.617 1.755-1.247 2.119 1.504-1.756 1.247-2.119-1.504Z" fill="url(#overlay-icon-d)"></path><path d="m16.604 29.367 1.4.994c1.2.852 2.791.852 3.992 0l1.4-.994-1.755-1.247-.786.558a1.472 1.472 0 0 1-1.71 0l-.786-.558-1.756 1.247Z" fill="url(#overlay-icon-e)"></path><path d="m23.396 26.874 1.756 1.247 2.119-1.504-1.756-1.247-2.119 1.504Z" fill="url(#overlay-icon-f)"></path></g><path d="m11.057 14.101 7.566-4.708a2.608 2.608 0 0 1 2.754 0l7.566 4.708a2.234 2.234 0 0 1 0 3.798l-7.566 4.708a2.608 2.608 0 0 1-2.754 0l-7.566-4.708a2.234 2.234 0 0 1 0-3.798Z" fill="url(#overlay-icon-g)"></path><defs><linearGradient id="overlay-icon-a" x1="0" y1="40" x2="40" y2="0" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="overlay-icon-b" x1="10" y1="31" x2="17.643" y2="15.274" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="overlay-icon-c" x1="10" y1="31" x2="17.643" y2="15.274" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="overlay-icon-d" x1="10" y1="31" x2="17.643" y2="15.274" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="overlay-icon-e" x1="10" y1="31" x2="17.643" y2="15.274" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="overlay-icon-f" x1="10" y1="31" x2="17.643" y2="15.274" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="overlay-icon-g" x1="10" y1="23" x2="23.154" y2="4.208" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
